module.exports = __webpack_public_path__ + "media/images/konintodoke/other_services/services07-2d88c727876ced7f03fd4f5e031561c0.jpg";